import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';
import ShiftTable from './ShiftTable';
import {downloadShiftsCsv} from './shiftExport';

export default function Shifts({site}) {
  const reportId = site.reportId || site.siteId;
  return <Accordion disableGutters elevation={0} slotProps={{transition: {unmountOnExit: true}}}
    sx={{bgcolor: '#356c920d', border: '1px solid #356c9233', borderRadius: '4px',
      '&:before': {display: 'none'}, '&.Mui-expanded': {margin: 0}}}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`shifts-${reportId}-heading`} aria-controls={`shifts-${reportId}`}>
      <Typography variant="body2" sx={{color: '#356c92', fontWeight: 600}}>All Shifts</Typography>
    </AccordionSummary>
    <AccordionDetails id={`shifts-${reportId}`}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 2}}>
        <Typography variant="body2" color="text.secondary">Times are shown in Europe/London.</Typography>
        <Button size="small" variant="outlined" startIcon={<DownloadIcon />} sx={{flexShrink: 0}}
          disabled={!site.shifts?.length} onClick={() => downloadShiftsCsv(site)}>Export CSV</Button>
      </Box>
      {site.shifts?.length ? <ShiftTable shifts={site.shifts} name={`Shifts for ${site.name}`} />
        : <Typography variant="body2" color="text.secondary">{site.shifts ? 'No shifts in this period.' : 'Shift details are not available.'}</Typography>}
    </AccordionDetails>
  </Accordion>;
}
